import { render, staticRenderFns } from "./PMVersionPage.vue?vue&type=template&id=5acb8145&"
import script from "./PMVersionPage.vue?vue&type=script&lang=ts&"
export * from "./PMVersionPage.vue?vue&type=script&lang=ts&"
import style0 from "./PMVersionPage.vue?vue&type=style&index=0&id=5acb8145&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports